export enum SupplierQueryField {
  // ---------- SUPPLIER INFO ----------
  id = 'id',
  name = 'name',
  externalId = 'externalId',
  employeeCount = 'employeeCount',
  industry = 'industry',
  legalType = 'legalType',
  relationship = 'relationship',
  locationGroupName = 'locationGroupName',
  locationGroupExternalId = 'locationGroupExternalId',
  prequalificationLevel = 'prequalificationLevel',
  prequalificationTradesName = 'prequalificationTradesName',
  tagCount = 'tagCount',
  tagList = 'tagList',
  // ---------- CONTRACTS ----------
  activeContractCount = 'activeContractCount',
  lastContractDate = 'lastContractDate',
  quotationCount = 'quotationCount',
  quotationSuccessRate = 'quotationSuccessRate',
  // ---------- PRODUCTS ----------
  productId = 'productId',
  productName = 'productName',
  productExternalId = 'productExternalId',
  productCategory = 'productCategory',
  // ---------- SERVICES ----------
  serviceId = 'serviceId',
  serviceName = 'serviceName',
  serviceExternalId = 'serviceExternalId',
  serviceCategory = 'serviceCategory',
  // ---------- ORDERS ----------
  orderLastDate = 'orderLastDate',
  orderVolumeYear = 'orderVolumeYear',
  orderCountYear = 'orderCountYear',
  orderVolume = 'orderVolume',
  orderCount = 'orderCount',
  // ---------- FINANCIALS ----------
  revenue = 'revenue',
  ebit = 'ebit',
  peRatio = 'peRatio',
  // ---------- LOCATION ----------
  addressCountry = 'addressCountry',
  addressCity = 'addressCity',
  locationRadius = 'locationRadius',
  // ---------- COMMODITY GROUP ----------
  commodityGroup = 'commodityGroup',
  // ---------- SOURCE SYSTEM ----------
  sourceSystemName = 'sourceSystemName',
}

export enum SupplierQueryFieldGroup {
  supplier = 'supplier',
  contract = 'contract',
  product = 'product',
  service = 'service',
  order = 'order',
  financial = 'financial',
  location = 'location',
  sourceSystem = 'sourceSystem',
  commodityGroup = 'commodityGroup',
}
